import { Link } from "gatsby";
import React from "react";

import useWindowSize from "../hooks/useWindowSize";
import Hamburger from "../images/svg/Hamburger.svg";
import * as styles from "../styles/HeaderNav.module.css";

export interface HeaderNavProps {
  onHamburgerClicked: () => void;
}

const goTo = (location: string) => {
  window.location.replace(location);
};

const HeaderNav = (props: HeaderNavProps) => {
  const { width } = useWindowSize();

  if (width > 800) {
    return (
      <div className={styles.container}>
        <div className={styles.entry}>
          <a
            onClick={() => {
              goTo("/#about_us");
            }}
          >
            About us
          </a>
          <div
            style={{
              backgroundColor: "var(--header-footer-font-color)",
              width: 10,
              height: 10,
            }}
          />
        </div>
        <div className={styles.entry}>
          <a
            onClick={() => {
              goTo("/#products");
            }}
          >
            Products
          </a>
          <div
            style={{
              backgroundColor: "var(--header-footer-font-color)",
              width: 10,
              height: 10,
            }}
          />
        </div>
        <div className={styles.entry}>
          <a
            onClick={() => {
              goTo("/#privacy");
            }}
          >
            Privacy
          </a>
          <div
            style={{
              backgroundColor: "var(--header-footer-font-color)",
              width: 10,
              height: 10,
            }}
          />
        </div>
        <div className={styles.entry}>
          <a
            onClick={() => {
              goTo("/#goals");
            }}
          >
            Goals
          </a>
          <div
            style={{
              backgroundColor: "var(--header-footer-font-color)",
              width: 10,
              height: 10,
            }}
          />
        </div>
        <div className={styles.entry}>
          <a href={"/faq"}>FAQ</a>
          <div
            style={{
              backgroundColor: "var(--header-footer-font-color)",
              width: 10,
              height: 10,
            }}
          />
        </div>
        <div className={styles.entry}>
          <a
            onClick={() => {
              goTo("/#contact");
            }}
          >
            Contact us
          </a>
          <div
            style={{
              backgroundColor: "var(--header-footer-font-color)",
              width: 10,
              height: 10,
            }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <Hamburger onClick={props.onHamburgerClicked} />
      </div>
    );
  }
};

export default HeaderNav;
